import React , {Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import Modal_TipoViajes from './modal_tipoviajes';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import store from '../../store';

const database=firebase.database();


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px',
	height: '500px'
	
  }
};

class TipoViajes extends Component{
	
	
	constructor(props){
		
		super(props);
		this.state={
			
			tipoViajes:[],
			paradas:false,
			keyRow:'',
			descripcion:'',
			nombretipoviaje:'',
			isActive:false,
			isActive2:false,
			estado:true,
			estadoBase : ''
			
		}

		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.handleClickClose=this.handleClickClose.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		this.updateRow=this.updateRow.bind(this);
		this.asignarAncho=this.asignarAncho.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);

	
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.updateRow();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
		
		
		this.setState({
			
			anchoAnterior:window.innerWidth,
			anchoActual:window.innerWidth
			
		})
		
		
	}
	
	
	updateRow = () => {
		let estadoBase = 'Activo';
		let {estado} = this.state;
		if (estado === false) {
			estadoBase = 'inactivo';
		} else if(estado === true){
			estadoBase = 'activo';
		}
		firebase.database().ref().child('TiposViajes/'+this.state.keyRow).update({
			nombre:this.nombretipoviaje.value,
			descripcion:this.descripcion.value,
			paradas:this.state.paradas,
			estado:estadoBase
			})

	}

	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Bacer';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
	
	handleClickClose(){		
		Alert.closeAll();
	}
	
	componentWillMount(){

		Modal.setAppElement('body');
	}

	
	componentDidMount() {
		// this.sociosRef.once('value',this.gotDataSocios,this.errDataSocios);
		// this.vehiculosRef.on('value',this.gotDataVehiculos,this.errDataVehiculos);
		this.gotData();
	}

	handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({ [name]: value });
    }
	
	
	//get the data from the firebase and push them out
	gotData = () => {

		let tiposViajes = [];
		firebase.database().ref('TiposViajes').on('value' , snap =>{
			snap.forEach(element => {
				let datos = element.val();
				datos.key = element.key;
				if (datos.paradas === true) {
					datos.paradas = 'Si';
				}
				else if(datos.paradas === false){
					datos.paradas = 'No';
				}
				if (datos.estado===undefined) {
					datos.estado = '---';
				}
				tiposViajes.push(datos);
			})
			this.setState({tiposViajes});
			tiposViajes = [];
		})
	}

	
	errData = (err) => {
		console.log(err);
	}
	
	
	
	handleClick = (rowKey) => {
		let paradas = false;
		if(rowKey.paradas === 'Si'){
			paradas = true;
		}
		else if(rowKey.paradas === 'No'){
			paradas = false;
		}

		this.setState({
			keyRow:rowKey.key,
			nombretipoviaje:rowKey.nombre,
			descripcion:rowKey.descripcion,
			paradas, estadoBase:rowKey.estado
		})

		this.toggleModalUpdate();
	}

	handleClickDesactivar = (rowKey) => {
		let paradas = false, estado = true, estadoBase='';
		if(rowKey.paradas === 'Si'){
			paradas = true;
		}
		else if(rowKey.paradas === 'No'){
			paradas = false;
		}
		if (rowKey.estado==='activo') {
			estado = true;
			estadoBase = 'inactivo';
		} else if(rowKey.estado==='inactivo'){
			estado = false;
			estadoBase = 'activo';
		}

		this.setState({
			keyRow:rowKey.key,
			nombretipoviaje:rowKey.nombre,
			descripcion:rowKey.descripcion,
			paradas, estado, estadoBase
		})

		this.toggleModalDesactivar();
	}
	
	toggleModalUpdate=()=>{
		
		this.setState({
			uploadValue:0,
			isActive:!this.state.isActive
		})		
	}

	toggleModalDesactivar=()=>{
		
		this.setState({
			desactivateValue:0,
			isActive2:!this.state.isActive2
		})		
	}
	
	ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	imgFormatter(cell,row) {
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}

	imgFormatterDesactivar(cell,row) {
		return  <button className="btn btn-warning btn-sm" onClick={() => {this.handleClickDesactivar(row)}} >Estado</button>;
	}
	
	asignarAncho(){
		
		if(this.state.anchoAnterior!==window.innerWidth){
			
			this.setState({
				
				anchoActual:window.innerWidth
				
			})
			
		}
		
		
	}

	handleSubmit(event){
			
	}
	
	render(){
		
		return(
		
			<div className="Vehiculos container" onClick={this.ocultarMenu}>
				
				<h1 className="titulo">Tipos de Viajes</h1>
		
	
			
			<Modal_TipoViajes/>
			{this.state.template ? <Alert  timeout='none' stack={{limit: 1}} contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 1}} html={true} />}
			
	
			
			<BootstrapTable data={ this.state.tiposViajes }
				 ref='table'			 
				 pagination={ true }
				 search={ true }
				 hover
				 >
				 <TableHeaderColumn  dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
				 <TableHeaderColumn  dataField='nombre' dataAlign='center' dataSort={true}>Nombre</TableHeaderColumn>
				 <TableHeaderColumn  dataField='descripcion' dataAlign='center' dataSort={true}>Descripcion</TableHeaderColumn>
				 <TableHeaderColumn  dataField='paradas' dataAlign='center' dataSort={true}>Paradas</TableHeaderColumn>
				 <TableHeaderColumn  dataField='estado' dataAlign='center' dataSort={true}>Estado</TableHeaderColumn>	
				 <TableHeaderColumn  dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
				 <TableHeaderColumn  dataField='edit' dataAlign='center' dataFormat={ this.imgFormatterDesactivar.bind(this) }>Desactivar</TableHeaderColumn>	 
			  </BootstrapTable>
					
			  <Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate}  style={customStyles} >

						<form method="POST" action="" onSubmit={this.handleClickAlerta} >
			  
								<h3>Modificar Tipo de Viaje</h3>
								<hr/>
								<input type="hidden" ref={input => {this.keyRow=input;}} value={this.state.keyRow}/>
								
								<div className="form-group">
								<label htmlFor="nombre">Nombre</label>
								<input type="text" name="nombre" className="form-control"
								placeholder="Nombre" required autoComplete="off"
								ref={input => {this.nombretipoviaje=input;}} defaultValue={this.state.nombretipoviaje}
								
								/>
							</div>
							<div className="form-group">
								<label htmlFor="dui">Descripcion</label>
								
								<textarea className="form-control" 
								placeholder="Dui" required autoComplete="off"
								ref={input => {this.descripcion=input;}} defaultValue={this.state.descripcion}
								/>
							</div>
							<div className="col-5 col-md-5 form-check" style={{left: '15px' }}>
								<div className="form-group row">
									<label htmlFor='paradas'>Paradas</label>
									<input type="checkbox" onChange={this.handleInputChange} name='paradas' className="form-check-input" id="paradas" checked={this.state.paradas} defaultValue={this.state.paradas}/>
								</div>
							</div>
							<button className="btn btn-primary buttons" type="submit">Guardar</button>
						</form>
								<button className="btn btn-default buttons btnmargin" onClick={this.toggleModalUpdate}>Cerrar</button>
					</Modal>

					<Modal isOpen={this.state.isActive2} onRequestClose={this.toggleModalDesactivar}  style={customStyles} >

						<form method="POST" action="" onSubmit={this.handleClickAlerta} >

								<h3>Desactivar Tipo de Viaje</h3>
								<hr/>
								<input type="hidden" ref={input => {this.keyRow=input;}} value={this.state.keyRow}/>
								
								<div className="form-group">
								<label htmlFor="nombre">Nombre</label>
								<input type="text" name="nombre" className="form-control"
								placeholder="Nombre" readOnly autoComplete="off"
								ref={input => {this.nombretipoviaje=input;}} defaultValue={this.state.nombretipoviaje}
								
								/>
							</div>
							<div className="form-group">
								<label htmlFor="dui">Descripcion</label>
								
								<textarea className="form-control" 
								placeholder="Dui" readOnly autoComplete="off"
								ref={input => {this.descripcion=input;}} defaultValue={this.state.descripcion}
								/>
							</div>
							<div className="col-5 col-md-5 form-check" style={{left: '15px' }}>
								<div className="form-group row">
									<label htmlFor='paradas'>Paradas</label>
									<input type="checkbox" readOnly onChange={this.handleInputChange} name='paradas' className="form-check-input" id="paradas" checked={this.state.paradas} />
								</div>
							</div>
							<div className="col-5 col-md-5 form-check" style={{left: '15px' }}>
								<div className="form-group row">
									<label htmlFor='estado'>Activar</label>
									<input type="checkbox" onChange={this.handleInputChange} name='estado' className="form-check-input" id="estado" checked={this.state.estado} />
								</div>
							</div>
							<button className="btn btn-primary buttons" type="submit">Desactivar</button>
						</form>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModalDesactivar}>Cerrar</button>
					</Modal>
			</div>
			
		);
		
		
	}
	
	
}


export default TipoViajes;


// WEBPACK FOOTER //
// ./src/Components/Tipo_Viajes/TipoViajes.jsx